/* tfp-versandrechner.js - Versandrechner im Warenkorb (Cockpit q38, 11.10.2026).
 * Markup: snippets/tfp-versandrechner.liquid. Fragt nur Shopifys Warenkorb-Endpunkte ab
 * (cart/prepare_shipping_rates.json, cart/async_shipping_rates.json). Speichert nichts.
 * Ohne PLZ wird eine Beispiel-PLZ des Landes verwendet (Shopify verlangt eine PLZ); das steht im Ergebnis.
 */
(function () {
  if (window.__tfpVersandrechner) return;
  window.__tfpVersandrechner = true;

  /* Beispiel-PLZ (und Region, falls Shopify sie verlangt) je Land, Schlüssel = Optionswert aus country_option_tags. */
  var SAMPLE = {
    'Germany': { zip: '10115' },
    'Poland': { zip: '00-001' },
    'Netherlands': { zip: '1011 AB' },
    'Belgium': { zip: '1000' },
    'Austria': { zip: '1010' },
    'France': { zip: '75001' },
    'Italy': { zip: '00100', province: 'RM' },
    'Spain': { zip: '28001', province: 'M' },
    'Denmark': { zip: '1050' },
    'Sweden': { zip: '111 20' },
    'Czech Republic': { zip: '110 00' },
    'Czechia': { zip: '110 00' },
    'Luxembourg': { zip: '1111' },
    'Switzerland': { zip: '8001' },
    'Liechtenstein': { zip: '9490' },
    'United Kingdom': { zip: 'SW1A 1AA' },
    'Norway': { zip: '0150' },
    'United States': { zip: '10001', province: 'NY' },
    'Canada': { zip: 'M5H 2N2', province: 'ON' },
    'Australia': { zip: '2000', province: 'NSW' },
    'Hungary': { zip: '1011' },
    'Slovakia': { zip: '811 01' },
    'Slovenia': { zip: '1000' },
    'Croatia': { zip: '10000' },
    'Romania': { zip: '010011' },
    'Bulgaria': { zip: '1000' },
    'Lithuania': { zip: '01100' },
    'Latvia': { zip: 'LV-1050' },
    'Estonia': { zip: '10111' },
    'Finland': { zip: '00100' },
    'Portugal': { zip: '1100-148' },
    'Greece': { zip: '105 57' }
  };

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function txt(box, key) { return box.getAttribute('data-t-' + key) || ''; }

  function provincesOf(option) {
    if (!option) return [];
    try { return JSON.parse(option.getAttribute('data-provinces') || '[]') || []; } catch (e) { return []; }
  }

  function fillRegions(box) {
    var country = box.querySelector('[data-tfp-vr-country]');
    var wrap = box.querySelector('[data-tfp-vr-region-wrap]');
    var region = box.querySelector('[data-tfp-vr-region]');
    if (!country || !wrap || !region) return;
    var list = provincesOf(country.options[country.selectedIndex]);
    region.innerHTML = '';
    if (!list.length) { wrap.hidden = true; return; }
    var first = document.createElement('option');
    first.value = '';
    first.textContent = txt(box, 'region-choose');
    region.appendChild(first);
    list.forEach(function (p) {
      var o = document.createElement('option');
      o.value = p[0];
      o.textContent = p[1] || p[0];
      region.appendChild(o);
    });
    wrap.hidden = false;
  }

  function preselect(box) {
    var country = box.querySelector('[data-tfp-vr-country]');
    if (!country) return;
    var iso = box.getAttribute('data-country-iso');
    var name = (box.getAttribute('data-country-name') || '').trim().toLowerCase();
    var lang = box.getAttribute('data-lang');
    var want = null;
    if (box.getAttribute('data-inland') === 'true') {
      want = null; /* Inland: Kunde wählt das Ausland selbst */
    } else if (iso === 'DE' && lang === 'pl') {
      want = 'Poland';
    } else if (iso !== 'DE' || lang === 'de') {
      for (var i = 0; i < country.options.length; i++) {
        var o = country.options[i];
        if (o.value && (o.textContent.trim().toLowerCase() === name || o.value.toLowerCase() === name)) { want = o.value; break; }
      }
    }
    if (want) {
      for (var j = 0; j < country.options.length; j++) {
        if (country.options[j].value === want) { country.selectedIndex = j; break; }
      }
    }
    fillRegions(box);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-tfp-vr]:not([data-tfp-vr-ready])').forEach(function (box) {
      box.setAttribute('data-tfp-vr-ready', '');
      preselect(box);
    });
  }

  function encode(params) {
    return Object.keys(params).filter(function (k) { return params[k] !== undefined && params[k] !== null; })
      .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); }).join('&');
  }

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function messageFrom(data) {
    if (!data || typeof data !== 'object') return '';
    var out = [];
    Object.keys(data).forEach(function (k) {
      var v = data[k];
      if (Array.isArray(v)) out.push(v.join(' ')); else if (typeof v === 'string') out.push(v);
    });
    return out.join(' ');
  }

  function fetchRates(params) {
    var body = encode(params);
    return fetch(root() + 'cart/prepare_shipping_rates.json', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: body
    }).then(function (res) {
      if (res.status === 422) {
        return res.json().catch(function () { return {}; }).then(function (d) { var e = new Error(messageFrom(d)); e.user = true; throw e; });
      }
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var tries = 0;
      function poll() {
        tries++;
        return fetch(root() + 'cart/async_shipping_rates.json?' + body, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.text().then(function (t) { return { status: r.status, text: t }; }); })
          .then(function (r) {
            var t = (r.text || '').trim();
            if (r.status === 200 && t && t !== 'null') {
              var d = JSON.parse(t);
              return (d && d.shipping_rates) || [];
            }
            if (r.status === 422) { var e = new Error(messageFrom(JSON.parse(t || '{}'))); e.user = true; throw e; }
            if (tries >= 10) throw new Error('timeout');
            return wait(700).then(poll);
          });
      }
      return wait(400).then(poll);
    });
  }

  function money(box, amount, currency) {
    var lang = box.getAttribute('data-lang') || 'de';
    var cur = currency || box.getAttribute('data-currency') || 'EUR';
    var n = parseFloat(amount);
    if (isNaN(n)) return amount;
    try { return new Intl.NumberFormat(lang === 'en' ? 'en-IE' : lang, { style: 'currency', currency: cur }).format(n); }
    catch (e) { return n.toFixed(2) + ' ' + cur; }
  }

  function render(box, html) {
    var res = box.querySelector('[data-tfp-vr-result]');
    if (res) res.innerHTML = html;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function days(box, rate) {
    var min = null, max = null;
    if (rate.delivery_days && rate.delivery_days.length) { min = rate.delivery_days[0]; max = rate.delivery_days[rate.delivery_days.length - 1]; }
    else if (rate.description) {
      var m = String(rate.description).match(/(\d+)\s*[-–]\s*(\d+)/);
      if (m) { min = m[1]; max = m[2]; }
    }
    if (min === null) return '';
    return txt(box, 'days').replace('{min}', min).replace('{max}', max);
  }

  function calc(box) {
    var countrySel = box.querySelector('[data-tfp-vr-country]');
    var regionSel = box.querySelector('[data-tfp-vr-region]');
    var regionWrap = box.querySelector('[data-tfp-vr-region-wrap]');
    var zipIn = box.querySelector('[data-tfp-vr-zip]');
    var btn = box.querySelector('[data-tfp-vr-calc]');
    var country = countrySel ? countrySel.value : '';
    if (!country) { render(box, '<p class="tfp-vr__msg tfp-vr__msg--warn">' + esc(txt(box, 'need-country')) + '</p>'); return; }
    var countryLabel = countrySel.options[countrySel.selectedIndex].textContent.trim();
    var zip = zipIn ? zipIn.value.trim() : '';
    var hasRegions = regionWrap && !regionWrap.hidden;
    var province = hasRegions && regionSel ? regionSel.value : '';
    var sample = SAMPLE[country];
    var usedSample = false;
    if (!zip) {
      if (!sample) { render(box, '<p class="tfp-vr__msg tfp-vr__msg--warn">' + esc(txt(box, 'need-zip')) + '</p>'); return; }
      zip = sample.zip;
      usedSample = true;
      if (hasRegions && !province && sample.province) province = sample.province;
    }
    /* Region nur mitsenden, wenn gewählt oder aus der Beispiel-PLZ bekannt; verlangt Shopify sie, kommt dessen Meldung. */

    var params = { 'shipping_address[country]': country, 'shipping_address[zip]': zip };
    if (province) params['shipping_address[province]'] = province;

    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    render(box, '<p class="tfp-vr__msg">' + esc(txt(box, 'busy')) + '</p>');

    fetchRates(params).then(function (rates) {
      if (!rates.length) { render(box, '<p class="tfp-vr__msg tfp-vr__msg--warn">' + esc(txt(box, 'none')) + '</p>'); return; }
      var rows = rates.map(function (r) {
        var price = parseFloat(r.price) === 0 ? txt(box, 'free') : money(box, r.price, r.currency);
        var d = days(box, r);
        return '<li class="tfp-vr__rate"><span class="tfp-vr__rate-name">' + esc(r.presentment_name || r.name) +
          (d ? '<small class="tfp-vr__rate-days">' + esc(d) + '</small>' : '') +
          '</span><strong class="tfp-vr__rate-price">' + esc(price) + '</strong></li>';
      }).join('');
      var head = '<p class="tfp-vr__result-head">' + esc(txt(box, 'result')) + ' <strong>' + esc(countryLabel) + '</strong></p>';
      var note = usedSample ? '<p class="tfp-vr__msg tfp-vr__msg--small">' + esc(txt(box, 'sample').replace('{zip}', zip)) + '</p>' : '';
      /* Codex v50 Befund 3 (11.10.2026): Shopify liefert die Raten in EUR, auch wenn der Warenkorb in CHF/GBP/USD … steht.
       * Dann nur einen Hinweis zeigen (keine eigene Umrechnung). Nur wenn die Antwort wirklich EUR meldet. */
      var cartCur = (box.getAttribute('data-currency') || '').toUpperCase();
      var eurRate = rates.some(function (r) { return String(r.currency || '').toUpperCase() === 'EUR'; });
      if (eurRate && cartCur && cartCur !== 'EUR' && txt(box, 'currency-eur')) {
        note += '<p class="tfp-vr__msg tfp-vr__msg--small tfp-vr__msg--currency" data-tfp-vr-currency-note>' + esc(txt(box, 'currency-eur')) + '</p>';
      }
      render(box, head + '<ul class="tfp-vr__rates" role="list">' + rows + '</ul>' + note);
    }).catch(function (err) {
      var extra = err && err.user && err.message ? ' ' + err.message : '';
      render(box, '<p class="tfp-vr__msg tfp-vr__msg--warn">' + esc(txt(box, 'error') + extra) + '</p>');
    }).then(function () {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    });
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-tfp-vr-country]');
    if (!sel) return;
    var box = sel.closest('[data-tfp-vr]');
    fillRegions(box);
    render(box, '');
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tfp-vr-calc]');
    if (!btn) return;
    e.preventDefault();
    calc(btn.closest('[data-tfp-vr]'));
  });

  /* Enter in einem Feld darf das Warenkorb-Formular nicht absenden. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var field = e.target.closest && e.target.closest('[data-tfp-vr] input, [data-tfp-vr] select');
    if (!field) return;
    e.preventDefault();
    calc(field.closest('[data-tfp-vr]'));
  });

  function boot() {
    init(document);
    /* Drawer lädt /cart?view=jsonData nach: neue Rechner einmalig vorbelegen. */
    if ('MutationObserver' in window) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; init(document); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
